import React from 'react';
import { Modal, message, Spin, Button } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import format from '../../../shared/format';


class FinanceAdjustDetails extends React.Component {
    state = {
        loading: false,
        visible: false,
        data: {},
    }

    show = (relatedId) => {
        this.setState({
            visible: true,
        }, () => {
            this.queryInvFinancialAdjust(relatedId);
        });
    }

    //获取最新财务数据调整
    queryInvFinancialAdjust = (relatedId) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryInvFinancialAdjust,
            data: {
                id: relatedId,
            },
            dataType: 'json',
            doneResult: res => {
                const { investigationFinancialAdjust } = res;
                const { applyType, costType, customerConfirmFlag } = investigationFinancialAdjust;
                this.setState({
                    data: {
                        ...investigationFinancialAdjust,
                        applyType: (applyType || '').split(','),
                        costType: (costType || '').split(','),
                        customerConfirmFlagShow: customerConfirmFlag === 'YES' ? '有': customerConfirmFlag === 'NO' ? '无' : '',
                    },
                });
            }
        };
        $.sendRequest(options);
    }


    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            data: {},
        });
    }


    downLoadFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    getDataList = () => {
        const {
            data,
        } = this.state;
        const {
            costType = [],
            applyTypeShow,
            customerCompanyName,
            customerConfirmFlagShow,
            investigationJdeContractCode,
            costTypeShow,
            serviceInvoicedAmount,
            serviceExpectedPaymentAmount,
            serviceSubsequentPaymentAmount,
            serviceActualTotalAmount,
            serviceCtmsSignAmount,
            ptInvoicedAmount,
            ptExpectedPaymentAmount,
            ptSubsequentPaymentAmount,
            ptActualTotalAmount,
            ptCtmsSignAmount,
            shouldAdjustAmount,
            estimateIncomeAmount,
            costIncrDecr,
            adjustDesc,
            ossFileList = [],
        } = data;
        const showService = costType.length === 2 ? true : costType[0] === 'SERVICE_COST';
        const showPt = costType.length === 2 ? true : costType[0] === 'PT_COST';
        return (
            <div>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>开启财务数据调整备注：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {adjustDesc}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>申请类型：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {applyTypeShow}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>客户名称：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {customerCompanyName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>有无客户确认材料：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {customerConfirmFlagShow}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>附件：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {ossFileList.map(el => <a onClick={() => this.downLoadFile(el.id)}>{el.fileName}<br /></a>)}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>JDE项目号：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {investigationJdeContractCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>申请开票费用类型：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {costTypeShow}
                    </div>
                </li>
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>已开票金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceInvoicedAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>预计本次请款金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceExpectedPaymentAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>后期还待请款金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceSubsequentPaymentAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>实际总金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceActualTotalAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>CTMS登记签署金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceCtmsSignAmount)}
                        </div>
                    </li>
                }

                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>已开票金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptInvoicedAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>预计本次请款金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptExpectedPaymentAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>后期还待请款金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptSubsequentPaymentAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>实际总金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptActualTotalAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>CTMS登记签署金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptCtmsSignAmount)}
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>本次应调整金额：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', shouldAdjustAmount)}
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>预估收入影响金额（仅影响审批流）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', estimateIncomeAmount)}
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>费用增减：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {costIncrDecr}
                        </div>
                    </li>
                }
                
            </div>
        )
    }

    render() {
        const { visible, loading, type } = this.state;
        return (
            <Modal
                title={'财务数据调整详情'}
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
                footer={<Button key="cancel" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            {this.getDataList()}
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default FinanceAdjustDetails;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/FinanceAdjustDetails.js